import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import WhyUsNew from "../WhyUsNew/WhyUsNew";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import upArrow from "../../../../src/Images/New_Home/images/up.svg";
import  down from "../../../../src/Images/New_Home/images/down.png";
import Home_New from "../../../../src/Images/New_Home/home-new_banner.png";
import homeSlider4 from "../../../../src/Images/New_Home/homeSlider4.png";
import homeSlider2 from "../../../../src/Images/New_Home/homeSlider2.png";
import homeSlider1 from "../../../../src/Images/New_Home/new-homeSlider1.png";
//import tradeoptionschart from "../../../../src/Images/New_Home/tradeoptions-realtimecharts.png";
import tradeoptionschart from "../../../../src/Images/New_Home/moneysukh-traderedge2.png";
import new_pricing from "../../../../src/Images/New_Home/home-new_pricing.png";
import new_product1 from "../../../../src/Images/New_Home/home-new_product-1.png";
import new_product2 from "../../../../src/Images/New_Home/home-new_product-2.png";
import new_product3 from "../../../../src/Images/New_Home/home-new_product-3.png";
import new_product4 from "../../../../src/Images/New_Home/home-new_product-4.png";
import new_product5 from "../../../../src/Images/New_Home/home-new_product-5.png";
import new_product6 from "../../../../src/Images/New_Home/home-new_product-6.png";
import new_integration1 from "../../../../src/Images/New_Home/home-new_integration-1.png";
import new_integration2 from "../../../../src/Images/New_Home/home-new_integration-2.png";
import new_integration3 from "../../../../src/Images/New_Home/home-new_integration-3.png";
import TradeRadarnew from "../../../../src/Images/New_Home/TradeRadarnew.png";
import URLstateContext from "../../../provider/CommonContext";
import "./WelcomeNew.css";
import LSEGforecastingaward from "../../../../src/Images/New_Home/LSEG-forecastingaward.png";
import scanner from "../../../../src/Images/New_Home/scanner1.png";
import  "../../CtaForm/CtaForm.css"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import { setState, userSelector } from "../../features/User/UserSlice";
import Swal from "sweetalert2";
import OTPInput from "react-otp-input";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
import { ApiUrlDomain } from "../../Configration/Configrationnew";
function WelcomeNew() {
    const { isSuccess, isError } = useSelector(
        userSelector
    );
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    let navigate = useNavigate();
    let getData;
    const ArrowRight = <FontAwesomeIcon icon={faArrowRight} />
    const EyeSlash = <FontAwesomeIcon icon={faEyeSlash} />
    const Eye = <FontAwesomeIcon icon={faEye} />
    const [mobNumber, setMobNumber] = useState('');
    const [otpfieldenable, setotpfieldenable] = useState(false);
    const [otpis1, setotpis1] = useState('');
    const [mobile_l, setMobile_l] = useState('');
    const [newUserMoberror, setNewUserMoberror] = useState('');
    const [showpwdnew, setshowpwdnew] = useState(false);
    const [seconds, setSeconds] = useState(30);
    const [resendDisabled, setResendDisabled] = useState(true);
    const [cookies, setCookie] = useCookies(['LeadId']);
    const dispatch = useDispatch();
    const OtpSend = (e) => {
        e.preventDefault();
        // otp send api call
        if (mobNumber != "" && mobNumber.toString().length === 10) {
            axios.get(`${ApiUrlDomain}/otpSend?phone_no=${mobNumber}`).then((res) => {
                if (res.data == 'OTP sent successfully') {
                    setSeconds(30);
                    setResendDisabled(true);
                    setotpfieldenable(true);
                }

            }).catch((error) => {
                console.log(error);
            })
        } else {
            setNewUserMoberror("Please enter valid mobile number");
            return false;
        }
    }
    const verifyOtp = (e) => {
        e.preventDefault();
        const fullOtp = otpis1;
        axios.get(`${ApiUrlDomain}/otpValidate?phone_no=${mobNumber}&otp=${fullOtp}`).then((res) => {
            if (res.data == 'OTP validated successfully') {
                setotpis1('');
                axios.post(`${ApiUrlDomain}/signupRetriveLead`, { "phone": mobNumber }).then((res) => {
                    if (res && res.data.length > 0) {
                        const leadId = res.data[0].prospectID;
                        setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                        const payloadData = {
                            "RelatedProspectId": leadId,
                            "ActivityNote": "Your Activity Note",
                            "mx_Custom_1": "Home",
                            "mx_Custom_2": "Your Activity Note",
                            "mx_CustomObject_81": window.location.href
                        }
                        TrackApi(payloadData);
                        if (res.data[0].prospectStage == "Customer" && res.data[0].mx_Lead_Status == "Active" && res.data[0].mx_Status == "Enabled") {
                            dispatch(setState({
                                "email": mobNumber,
                                "name": "New user",
                                "ProspectStage": res.data[0].prospectStage,
                                "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                "mx_Status": res.data[0].mx_Status
                            }));
                            //  
                            localStorage.setItem('userlogin', true);
                            localStorage.setItem('email', mobNumber);
                            localStorage.setItem('ProspectStage', res.data[0].prospectStage);
                            localStorage.setItem('mx_Lead_Status', res.data[0].mx_Lead_Status);
                            localStorage.setItem('mx_Status', res.data[0].mx_Status);
                            localStorage.setItem('name', "New user");
                            localStorage.setItem('token', "jhjsdhjhjhd");
                            setotpfieldenable(false);
                            setMobNumber('');
                            TrackApi(payloadData);
                            window.open('https://online.moneysukh.com');
                        } else {
                            axios.post(`${ApiUrlDomain}/signupnewuser`, { Mobile: mobNumber, mx_Vendor_Unique_Id: res.data[0].mx_Vendor_Unique_Id }).then((resn) => {

                                dispatch(setState({
                                    "email": mobNumber,
                                    "name": "New user",
                                    "ProspectStage": res.data[0].prospectStage,
                                    "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                    "mx_Status": res.data[0].mx_Status
                                }));
                                //  
                                localStorage.setItem('userlogin', true);
                                localStorage.setItem('email', mobNumber);
                                localStorage.setItem('ProspectStage', res.data[0].prospectStage);
                                localStorage.setItem('mx_Lead_Status', res.data[0].mx_Lead_Status);
                                localStorage.setItem('mx_Status', res.data[0].mx_Status);
                                localStorage.setItem('name', "New user");
                                localStorage.setItem('token', "jhjsdhjhjhd");
                                setotpfieldenable(false);
                                setMobNumber('');
                                if (resn && resn.data && resn.data.uniqueid) {
                                    axios.post(`${ApiUrlDomain}/lsqupdate`, {
                                        "LeadId": leadId,
                                        "mx_Vendor_Unique_Id": resn.data.uniqueid
                                    }).then((tt) => {

                                    }).catch((errd) => {
                                        console.log(errd);
                                    })
                                }

                                let redirecturlsignup = document.createElement('a');
                                redirecturlsignup.href = resn.data.data[0].url;
                                redirecturlsignup.target = '_blank';
                                redirecturlsignup.style.display = 'none';
                                document.body.appendChild(redirecturlsignup);
                                redirecturlsignup.click();
                                document.body.removeChild(redirecturlsignup);
                                TrackApi(payloadData);

                            }).catch((error) => {
                                // setverifyloader(false);
                                dispatch(setState({
                                    "email": mobNumber,
                                    "name": "New user",
                                    "ProspectStage": res.data[0].prospectStage,
                                    "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                    "mx_Status": res.data[0].mx_Status
                                }));
                                localStorage.setItem('userlogin', true);
                                localStorage.setItem('email', mobNumber);
                                localStorage.setItem('ProspectStage', res.data[0].prospectStage);
                                localStorage.setItem('mx_Lead_Status', res.data[0].mx_Lead_Status);
                                localStorage.setItem('mx_Status', res.data[0].mx_Status);
                                localStorage.setItem('name', "New user");
                                localStorage.setItem('token', "jhjsdhjhjhd");
                                setotpfieldenable(false);
                                setMobNumber('');
                                let redirecturlsignup = document.createElement('a');
                                redirecturlsignup.href = "https://kyc.moneysukh.com";
                                redirecturlsignup.target = '_blank';
                                redirecturlsignup.style.display = 'none';
                                document.body.appendChild(redirecturlsignup);
                                redirecturlsignup.click();
                                document.body.removeChild(redirecturlsignup);
                                TrackApi(payloadData);
                                console.log(error);
                            })
                        }

                    } else {
                        axios.post(`${ApiUrlDomain}/signupnewuser`, { Mobile: mobNumber, mx_Vendor_Unique_Id: "" }).then((resurl) => {
                            dispatch(setState({
                                "email": mobNumber,
                                "name": "New user"
                            }));
                            localStorage.setItem('userlogin', true);
                            localStorage.setItem('email', mobNumber);
                            localStorage.setItem('name', "New user");
                            localStorage.setItem('token', "jhjsdhjhjhd");
                            setotpfieldenable(false);
                            setMobNumber('');
                            // window.open('https://kyc.moneysukh.com');
                            let redirecturlsignup = document.createElement('a');
                            redirecturlsignup.href = resurl.data.data[0].url;
                            redirecturlsignup.target = '_blank';
                            redirecturlsignup.style.display = 'none';
                            document.body.appendChild(redirecturlsignup);
                            redirecturlsignup.click();
                            document.body.removeChild(redirecturlsignup);
                            // lead creat api
                            let bodydataleadapi = [
                                {
                                    "Attribute": "EmailAddress",
                                    "Value": ""
                                }, {
                                    "Attribute": "Phone",
                                    "Value": mobNumber
                                }, {
                                    "Attribute": "mx_Primary_Email_ID",
                                    "Value": ""
                                }, {
                                    "Attribute": "SearchBy",
                                    "Value": "mx_Primary_Email_ID"
                                },
                                {
                                    "Attribute": "Source",
                                    "Value": "Website"
                                }, {
                                    "Attribute": "FirstName",
                                    "Value": "New user"
                                },
                                {
                                    "Attribute": "mx_Vendor_Unique_Id",
                                    "Value": resurl.data.uniqueid
                                },
                                {
                                    "Attribute": "mx_website_URL_React",
                                    "Value": window.location.href
                                }

                            ];


                            axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async (responelead) => {
                                console.log("uhhhhhh", responelead);
                                //    const leadId=await responelead.data.Message && responelead.data.Message.Id;
                                const leadId = responelead && responelead.data && responelead.data.leadId;
                                setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                                const payloadData = {
                                    "RelatedProspectId": leadId,
                                    "ActivityNote": "Your Activity Note",
                                    "mx_Custom_1": "Home",
                                    "mx_Custom_2": "Your Activity Note",
                                    "mx_CustomObject_81": window.location.href
                                }
                                TrackApi(payloadData);
                            })
                            // lead creat api end code

                        }).catch((error) => {
                            console.log(error);
                            dispatch(setState({
                                "email": mobNumber,
                                "name": "New user"
                            }));
                            localStorage.setItem('userlogin', true);
                            localStorage.setItem('email', mobNumber);
                            localStorage.setItem('name', "New user");
                            localStorage.setItem('token', "jhjsdhjhjhd");
                            setotpfieldenable(false);
                            setMobNumber('');
                            // window.open('https://kyc.moneysukh.com');
                            let redirecturlsignup = document.createElement('a');
                            redirecturlsignup.href = 'https://kyc.moneysukh.com';
                            redirecturlsignup.target = '_blank';
                            redirecturlsignup.style.display = 'none';
                            document.body.appendChild(redirecturlsignup);
                            redirecturlsignup.click();
                            document.body.removeChild(redirecturlsignup);
                            // lead creat api
                            let bodydataleadapi = [
                                {
                                    "Attribute": "EmailAddress",
                                    "Value": ""
                                }, {
                                    "Attribute": "Phone",
                                    "Value": mobNumber
                                }, {
                                    "Attribute": "mx_Primary_Email_ID",
                                    "Value": ""
                                }, {
                                    "Attribute": "SearchBy",
                                    "Value": "mx_Primary_Email_ID"
                                },
                                {
                                    "Attribute": "Source",
                                    "Value": "Website"
                                }, {
                                    "Attribute": "FirstName",
                                    "Value": "New user"
                                },
                                {
                                    "Attribute": "mx_Vendor_Unique_Id",
                                    "Value": ""
                                },
                                {
                                    "Attribute": "mx_website_URL_React",
                                    "Value": window.location.href
                                }

                            ];


                            axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async (responelead) => {
                                console.log("uhhhhhh", responelead);
                                //    const leadId=await responelead.data.Message && responelead.data.Message.Id;
                                const leadId = responelead && responelead.data && responelead.data.leadId;
                                setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                                const payloadData = {
                                    "RelatedProspectId": leadId,
                                    "ActivityNote": "Your Activity Note",
                                    "mx_Custom_1": "Home",
                                    "mx_Custom_2": "Your Activity Note",
                                    "mx_CustomObject_81": window.location.href
                                }
                                TrackApi(payloadData);
                            })
                            // lead creat api end code

                        })


                    }

                }).catch((error) => {
                    console.log(error);
                })

            } else if (res.data == 'Invalid OTP') {
                Swal.fire(`Invalid OTP Please Enter Correct Otp`);
            }

        }).catch((error) => {
            console.log(error);
        })

    }

    
// top slider code updated
    const settings = {
        autoplay: true,
        accessibility: true,
        focusOnChange: true,
        autoplaySpeed: 6000,
        pauseOnHover: true,
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,

         afterChange: () => {
    const slides = document.querySelectorAll('.slick-slide');

    slides.forEach(slide => {
      const isHidden = slide.getAttribute('aria-hidden') === 'true';

      slide
        .querySelectorAll('a, button, input, textarea, select')
        .forEach(el => {
          el.setAttribute('tabindex', isHidden ? '-1' : '0');
        });
    });
  }

    };






    const routeMarginHome = () => {
        let path = `/margin-pledge`;
        navigate(path);
    }
    const routeKeevHome = () => {
        // let path = `/keev`;
        let path = `/Trade-Radar`;
        navigate(path);
    }
    const routeTradeRadarHome = () => {
        let path = `/trade-radar`;
        // navigate(path);
        window.open('https://learn.moneysukh.com/option-radar/')
    }
    const routeTradingViewHome = () => {
        let path = `/trading-view`;
        navigate(path);
    }
    const routeEventTrackerHome = () => {
        let path = `/market/event-tracker`;
        navigate(path);
    }
    const routeAlgoHome = () => {
        let path = `/AlgoTrading`;
        navigate(path);
    }
    const routeProductHome = () => {
        let path = `/Product`;
        navigate(path);
    }
    const routeFoxTraderHome = () => {
        let path = `/FoxTrader`;
        navigate(path);
    }
    const routeTradeTronHome = () => {
        let path = `/TradeTron`;
        navigate(path);
    }
    const routeQuantmanHome = () => {
        let path = `/Quantman`;
        navigate(path);
    }
    const routeAlgobullsHome = () => {
        let path = `/AlgoBulls`;
        navigate(path);
    }
    const routeIndexHome = () => {
        let path = `/market/stocks`;
        navigate(path);
    }
    const routePricingHome = () => {
        let path = `/Pricing`;
        navigate(path);
    }
    const routeSmartOptionHome = () => {
        // let path = 'https://learn.moneysukh.com/option-radar/';
        // window.location.href = path; 
        let path = `/SmartOptions`;
        navigate(path);

    };
    const routeBewareOnlineFraudsHome = () => {
        window.open('https://support.moneysukh.com/scam-alert/')

    };

   


    useEffect(() => {
        const getUrl = BaseURL + "Index";
        fetch(`${getUrl}`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
            })
            .catch((error) => {
            });
    }, [])
    const handleNewUserMobileNumber = event => {

        // if(event.target.value.length  == "" && event.target.value.length <= 10 ){
        //     document.getElementById('error').style.display ="block";
        // }
        // else{
        //     document.getElementById('error').style.display ="none";
        // }
        const re = /^[0-9\b]+$/;
        setMobile_l(event.target.value.length);
        if (event.target.value.length <= 10 && re.test(event.target.value)) {
            setMobNumber(parseInt(event.target.value));
        }

        if (event.target.value.length == 0) {
            setMobNumber("");
        }
        setNewUserMoberror("");

    };
    useEffect(() => {
        let timer;
        if (resendDisabled && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prev) => prev - 1);
            }, 1000);
        } else if (seconds === 0) {
            setResendDisabled(false);
        }

        return () => clearInterval(timer);
    }, [seconds, resendDisabled]);





    return (
        <>
            {/* <div className="SliderBigText"> {SliderBigText} </div> */}
            <main className="home-new-main">
                <section class="home_banner-sc home-sp-top">
                   
                    <div class="banner-slider center-slider">
                        <Slider {...settings}>
                            <div class="banner-slide">
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="banner-head fontNew">
                                                Trade with Trading view
                                            </div>
                                            <p>
                                                Trade directly with <span> trading view charts </span> with
                                                the help of world class tools.<span> with 100+ indicators. <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    routeTradingViewHome();
                                                }}>Know More...</a> </span>
                                            </p>
                                            {isSuccess ? "" : <div className="maincta_section">
                                                <form className="maincta_form">
                                                    <div class="form-row">
                                                        <div class="col-md-7 col-sm-12">
                                                            {otpfieldenable == false && <div class="input-group mb-2">
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">+91</div>
                                                                </div>
                                                                 <input type="number" class="form-control" id="EnterMobileNumberis" placeholder="Enter your Mobile number" value={mobNumber} onChange={handleNewUserMobileNumber} />
                                                                {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                        {/* aria-label="Enter Mobile Number" */}
                                                                        <button type="submit" class="btn btn-primary"  aria-label="Enter Mobile Number" onClick={(e) => OtpSend(e)}>{ArrowRight}</button>
                                                                    </div>
                                                                </div>
                                                            </div>}

                                                            {otpfieldenable && <div class="inputctaopt_grid">
                                                                <div class="input-group mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text" onClick={(e) => setshowpwdnew(!showpwdnew)}>{showpwdnew ? Eye : EyeSlash}</div>
                                                                    </div>
                                                                    <div class="inputctaopt_group form-control">
                                                                        <OTPInput
                                                                            inputType={showpwdnew ? "text" : "password"}

                                                                            value={otpis1}
                                                                            onChange={setotpis1}
                                                                            numInputs={4}
                                                                            renderSeparator={<span></span>}
                                                                            inputStyle={{
                                                                                width: '31px',
                                                                                height: '35px',
                                                                                margin: '0 8px',
                                                                                fontSize: '20px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #ccc',
                                                                                textAlign: 'center'
                                                                            }}
                                                                            renderInput={(props) => <input {...props} />}
                                                                        />
                                                                    </div>
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text">
                                                                            <button type="submit" class="btn btn-primary" onClick={(e) => verifyOtp(e)} >{ArrowRight}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 className="otprecvresend_text">{resendDisabled ? <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> : <span>Didn’t received? <span className="resent_otp" onClick={(e) => OtpSend(e)}>Resend OTP</span></span>}</h6>
                                                            </div>}
                                                        </div>
                                                        <div class="col-md-5 col-sm-12 text-center investmentmaincta_calmn">
                                                            <div className="investmentmaincta_list">
                                                                <div className="investmentmaincta_panel d-flex">
                                                                    <div className="scnner_panel">
                                                                        <img src={scanner} alt="Scan the QR Code"></img>
                                                                    </div>
                                                                    <div className="scnner_text">
                                                                        <p>Scan the QR Code to</p>
                                                                        <strong>Login<small>/</small>Register</strong>
                                                                        <p>from your mobile</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                            {/* 
                                            <button class="bttn" onClick={routeTradingViewHome}>
                                                GET STARTED
                                            </button> */}
                                            <div className="groupbtnn">
                                                {data && data.map((item, index) => (
                                                    <>
                                                        {index <= 1 ? (<button className="ineerbtn" onClick={routeIndexHome}>{item.co_name} <span className={(item.netchg > 0) ? "numt num-green" : "numt num-red"}>
                                                            {item.close_price}
                                                            {item.netchg > 0 ? <img className="arrowimg" src={upArrow} alt="Up Arrow" /> : <img className="arrowimg" src={down} alt="Down Arrow" />}</span></button>) : ''}

                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="img-container img-banner">
                                                <img src={homeSlider4} alt="Moneysukh Top Banner" class="img-fluid banner-5" />

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div class="banner-slide">
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-lg-7 col-md-12">
                                            {/* <h1 class="banner-head">
                                            Trade options 
                                            from <span className="event_new ">real time 
                                            charts</span>
                                            </h1> */}
                                            <h1 class="banner-head IntroducingTrader">
                                                Introducing
                                                <span className="event_new traderEdge">
                                                    TraderEdge</span>
                                            </h1>
                                            <p>
                                                {/* No more <span>toggling</span> in <span>search window</span> or <span>option
                                            chain</span> to create option positions.
                                             */}
                                                A new-age <span>trading platform specially</span> designed for <span>pro traders. </span>

                                                <a href="https://learn.moneysukh.com/traderedge-app/" target="_blank" onClick={(e) => {
                                                    //e.preventDefault();
                                                    // routeSmartOptionHome();
                                                }}>Know More...</a>

                                            </p>
                                            {/* <button class="bttn" onClick={routeSmartOptionHome}>
                                                GET STARTED
                                            </button> */}
                                            {isSuccess ? "" : <div className="maincta_section">
                                                <form className="maincta_form">
                                                    <div class="form-row">
                                                        <div class="col-md-7 col-sm-12">
                                                            {otpfieldenable == false && <div class="input-group mb-2">
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">+91</div>
                                                                </div>
                                                                <input type="number" class="form-control" id="EnterMobileNumberis" placeholder="Enter your Mobile number" value={mobNumber} onChange={handleNewUserMobileNumber} />
                                                                {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                          {/* aria-label="Enter Mobile Number" */}
                                                                        <button type="submit" class="btn btn-primary" aria-label="Enter Mobile Number" onClick={(e) => OtpSend(e)}>{ArrowRight}</button>
                                                                    </div>
                                                                </div>
                                                            </div>}

                                                            {otpfieldenable && <div class="inputctaopt_grid">
                                                                <div class="input-group mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text" onClick={(e) => setshowpwdnew(!showpwdnew)}>{showpwdnew ? Eye : EyeSlash}</div>
                                                                    </div>
                                                                    <div class="inputctaopt_group form-control">
                                                                        <OTPInput
                                                                            inputType={showpwdnew ? "text" : "password"}
                                                                            value={otpis1}
                                                                            onChange={setotpis1}
                                                                            numInputs={4}
                                                                            renderSeparator={<span></span>}
                                                                            inputStyle={{
                                                                                width: '31px',
                                                                                height: '35px',
                                                                                margin: '0 8px',
                                                                                fontSize: '20px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #ccc',
                                                                                textAlign: 'center'
                                                                            }}
                                                                            renderInput={(props) => <input {...props} />}
                                                                        />
                                                                    </div>
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text">
                                                                            <button type="submit" class="btn btn-primary" onClick={(e) => verifyOtp(e)} >{ArrowRight}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 className="otprecvresend_text">{resendDisabled ? <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> : <span>Didn’t received? <span className="resent_otp" onClick={(e) => OtpSend(e)}>Resend OTP</span></span>}</h6>
                                                            </div>}
                                                        </div>
                                                        <div class="col-md-5 col-sm-12 text-center investmentmaincta_calmn">
                                                            <div className="investmentmaincta_list">
                                                                <div className="investmentmaincta_panel d-flex">
                                                                    <div className="scnner_panel">
                                                                        <img src={scanner} alt="Scan the QR Code"></img>
                                                                    </div>
                                                                    <div className="scnner_text">
                                                                        <p>Scan the QR Code to</p>
                                                                        <strong>Login<small>/</small>Register</strong>
                                                                        <p>from your mobile</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                            <div className="groupbtnn">
                                                {data && data.map((item, index) => (
                                                    <>
                                                        {index <= 1 ? (<button className="ineerbtn" onClick={routeIndexHome}>{item.co_name} <span className={(item.netchg > 0) ? "numt num-green" : "numt num-red"}>
                                                            {item.close_price}
                                                            {item.netchg > 0 ? <img className="arrowimg" src={upArrow} alt="Up Arrow" /> : <img className="arrowimg" src={down} alt="Down Arrow" />}</span></button>) : ''}

                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-12">
                                            <div class="img-container img-banner">
                                                <img src={tradeoptionschart} alt="Moneysukh Top Banner" class="img-fluid banner-1" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="banner-slide">
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="banner-head fontNew">
                                                Algo Trading Simplified
                                            </div>

                                            <p>
                                                Automated trading for working professionals. Create ,automate and backtest. <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    routeAlgoHome();
                                                }}>Know More...</a>

                                            </p>
                                            {isSuccess ? "" : <div className="maincta_section">
                                                <form className="maincta_form">
                                                    <div class="form-row">
                                                        <div class="col-md-7 col-sm-12">
                                                            {otpfieldenable == false && <div class="input-group mb-2">
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">+91</div>
                                                                </div>
                                                                <input type="number" class="form-control" id="EnterMobileNumberis" placeholder="Enter your Mobile number" value={mobNumber} onChange={handleNewUserMobileNumber} />
                                                                {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                          {/* aria-label="Enter Mobile Number" */}
                                                                        <button type="submit" class="btn btn-primary" aria-label="Enter Mobile Number"onClick={(e) => OtpSend(e)}>{ArrowRight}</button>
                                                                    </div>
                                                                </div>
                                                            </div>}

                                                            {otpfieldenable && <div class="inputctaopt_grid">
                                                                <div class="input-group mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text" onClick={(e) => setshowpwdnew(!showpwdnew)}>{showpwdnew ? Eye : EyeSlash}</div>
                                                                    </div>
                                                                    <div class="inputctaopt_group form-control">
                                                                          <OTPInput
                                                                            inputType={showpwdnew ? "text" : "password"}

                                                                            value={otpis1}
                                                                            onChange={setotpis1}
                                                                            numInputs={4}
                                                                            renderSeparator={<span></span>}
                                                                            inputStyle={{
                                                                                width: '31px',
                                                                                height: '35px',
                                                                                margin: '0 8px',
                                                                                fontSize: '20px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #ccc',
                                                                                textAlign: 'center'
                                                                            }}
                                                                            renderInput={(props) => <input {...props} />}
                                                                        />
                                                                    </div>
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text">
                                                                            <button type="submit" class="btn btn-primary" onClick={(e) => verifyOtp(e)} >{ArrowRight}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 className="otprecvresend_text">{resendDisabled ? <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> : <span>Didn’t received? <span className="resent_otp" onClick={(e) => OtpSend(e)}>Resend OTP</span></span>}</h6>
                                                            </div>}
                                                        </div>
                                                        <div class="col-md-5 col-sm-12 text-center investmentmaincta_calmn">
                                                            <div className="investmentmaincta_list">
                                                                <div className="investmentmaincta_panel d-flex">
                                                                    <div className="scnner_panel">
                                                                        <img src={scanner} alt="Scan the QR Code"></img>
                                                                    </div>
                                                                    <div className="scnner_text">
                                                                        <p>Scan the QR Code to</p>
                                                                        <strong>Login<small>/</small>Register</strong>
                                                                        <p>from your mobile</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                            {/* <button class="bttn" onClick={routeAlgoHome}>
                                                GET STARTED
                                            </button> */}
                                            <div className="groupbtnn">
                                                {data && data.map((item, index) => (
                                                    <>
                                                        {index <= 1 ? (<button className="ineerbtn" onClick={routeIndexHome}>{item.co_name} <span className={(item.netchg > 0) ? "numt num-green" : "numt num-red"}>
                                                            {item.close_price}
                                                            {item.netchg > 0 ? <img className="arrowimg" src={upArrow} alt="Up Arrow" /> : <img className="arrowimg" src={down} alt="Down Arrow" />}</span></button>) : ''}

                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="img-container img-banner">
                                                <img src={homeSlider1} alt="Moneysukh Top Banner" class="img-fluid banner-3" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="banner-slide">
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-lg-7 col-md-12">
                                            <h1 class="banner-head">
                                                Get Pledge Benefits
                                            </h1>

                                            <p>
                                                <span>Missing</span> out <span>trading opportunities</span> due to
                                                <span> funds </span>
                                                shortage. Pledge your shares and get instant
                                                funding. <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    routeMarginHome();
                                                }} >Know More...</a>
                                            </p>
                                            {isSuccess ? "" : <div className="maincta_section">
                                                <form className="maincta_form">
                                                    <div class="form-row">
                                                        <div class="col-md-7 col-sm-12">
                                                            {otpfieldenable == false && <div class="input-group mb-2">
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">+91</div>
                                                                </div>
                                                                <input type="number" class="form-control" id="EnterMobileNumberis" placeholder="Enter your Mobile number" value={mobNumber} onChange={handleNewUserMobileNumber} />
                                                                {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                          {/* aria-label="Enter Mobile Number" */}
                                                                        <button type="submit" class="btn btn-primary" aria-label="Enter Mobile Number" onClick={(e) => OtpSend(e)}>{ArrowRight}</button>
                                                                    </div>
                                                                </div>
                                                            </div>}

                                                            {otpfieldenable && <div class="inputctaopt_grid">
                                                                <div class="input-group mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text" onClick={(e) => setshowpwdnew(!showpwdnew)}>{showpwdnew ? Eye : EyeSlash}</div>
                                                                    </div>
                                                                    <div class="inputctaopt_group form-control">
                                                                        <OTPInput
                                                                            inputType={showpwdnew ? "text" : "password"}

                                                                            value={otpis1}
                                                                            onChange={setotpis1}
                                                                            numInputs={4}
                                                                            renderSeparator={<span></span>}
                                                                            inputStyle={{
                                                                                width: '31px',
                                                                                height: '35px',
                                                                                margin: '0 8px',
                                                                                fontSize: '20px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #ccc',
                                                                                textAlign: 'center'
                                                                            }}
                                                                            renderInput={(props) => <input {...props} />}
                                                                        />
                                                                    </div>
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text">
                                                                            <button type="submit" class="btn btn-primary" onClick={(e) => verifyOtp(e)}>{ArrowRight}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 className="otprecvresend_text">{resendDisabled ? <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> : <span>Didn’t received? <span className="resent_otp" onClick={(e) => OtpSend(e)}>Resend OTP</span></span>}</h6>
                                                            </div>}
                                                        </div>
                                                        <div class="col-md-5 col-sm-12 text-center investmentmaincta_calmn">
                                                            <div className="investmentmaincta_list">
                                                                <div className="investmentmaincta_panel d-flex">
                                                                    <div className="scnner_panel">
                                                                        <img src={scanner} alt="Scan the QR Code"></img>
                                                                    </div>
                                                                    <div className="scnner_text">
                                                                        <p>Scan the QR Code to</p>
                                                                        <strong>Login<small>/</small>Register</strong>
                                                                        <p>from your mobile</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                            {/* <button class="bttn" onClick={routeMarginHome}>
                                                GET STARTED
                                            </button> */}
                                            <div className="groupbtnn">
                                                {data && data.map((item, index) => (
                                                    <>
                                                        {index <= 1 ? (<button className="ineerbtn" onClick={routeIndexHome}>{item.co_name} <span className={(item.netchg > 0) ? "numt num-green" : "numt num-red"}>
                                                            {item.close_price}
                                                            {item.netchg > 0 ? <img className="arrowimg" src={upArrow} alt="Up Arrow" /> : <img className="arrowimg" src={down} alt="Down Arrow" />}</span></button>) : ''}

                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-12">
                                            <div class="img-container img-banner">
                                                <img src={Home_New} alt="Moneysukh Top Banner" class="img-fluid banner-1" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="banner-slide">
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="banner-head fontNew banner-text trackStockHead">
                                                <span className="event-font">Track stocks with </span> <span className="event_new event-font">Event Tracker</span>
                                            </div>

                                            <p className="event-text">
                                                Get corporate announcements, <span>dividend
                                                    updates, bonus </span>, right issue at single click. <a href="#" onClick={(e) => {
                                                        e.preventDefault();
                                                        routeEventTrackerHome();
                                                    }} >Know More...</a>

                                            </p>
                                            {isSuccess ? "" : <div className="maincta_section">
                                                <form className="maincta_form">
                                                    <div class="form-row">
                                                        <div class="col-md-7 col-sm-12">
                                                            {otpfieldenable == false && <div class="input-group mb-2">
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">+91</div>
                                                                </div>
                                                                <input type="number" class="form-control" id="EnterMobileNumberis" placeholder="Enter your Mobile number" value={mobNumber} onChange={handleNewUserMobileNumber} />
                                                                {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                          {/* aria-label="Enter Mobile Number" */}
                                                                        <button type="submit" class="btn btn-primary"  aria-label="Enter Mobile Number" onClick={(e) => OtpSend(e)}>{ArrowRight}</button>
                                                                    </div>
                                                                </div>
                                                            </div>}

                                                            {otpfieldenable && <div class="inputctaopt_grid">
                                                                <div class="input-group mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text" onClick={(e) => setshowpwdnew(!showpwdnew)}>{showpwdnew ? Eye : EyeSlash}</div>
                                                                    </div>
                                                                    <div class="inputctaopt_group form-control">
                                                                     <OTPInput
                                                                            inputType={showpwdnew ? "text" : "password"}

                                                                            value={otpis1}
                                                                            onChange={setotpis1}
                                                                            numInputs={4}
                                                                            renderSeparator={<span></span>}
                                                                            inputStyle={{
                                                                                width: '31px',
                                                                                height: '35px',
                                                                                margin: '0 8px',
                                                                                fontSize: '20px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #ccc',
                                                                                textAlign: 'center'
                                                                            }}
                                                                            renderInput={(props) => <input {...props} />}
                                                                        />
                                                                    </div>
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text">
                                                                            <button type="submit" class="btn btn-primary" onClick={(e) => verifyOtp(e)} >{ArrowRight}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 className="otprecvresend_text">{resendDisabled ? <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> : <span>Didn’t received? <span className="resent_otp" onClick={(e) => OtpSend(e)}>Resend OTP</span></span>}</h6>
                                                            </div>}
                                                        </div>
                                                        <div class="col-md-5 col-sm-12 text-center investmentmaincta_calmn">
                                                            <div className="investmentmaincta_list">
                                                                <div className="investmentmaincta_panel d-flex">
                                                                    <div className="scnner_panel">
                                                                        <img src={scanner} alt="Scan the QR Code"></img>
                                                                    </div>
                                                                    <div className="scnner_text">
                                                                        <p>Scan the QR Code to</p>
                                                                        <strong>Login<small>/</small>Register</strong>
                                                                        <p>from your mobile</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                            {/* <button class="bttn" onClick={routeEventTrackerHome}>
                                                GET STARTED
                                            </button> */}
                                            <div className="groupbtnn">
                                                {data && data.map((item, index) => (
                                                    <>
                                                        {index <= 1 ? (<button className="ineerbtn" onClick={routeIndexHome}>{item.co_name} <span className={(item.netchg > 0) ? "numt num-green" : "numt num-red"}>
                                                            {item.close_price}
                                                            {item.netchg > 0 ? <img className="arrowimg" src={upArrow} alt="Up Arrow" /> : <img className="arrowimg" src={down} alt="Down Arrow" />}</span></button>) : ''}

                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="img-container img-banner">
                                                <img src={homeSlider2} alt="Moneysukh Top Banner" class="img-fluid banner-4" />

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            {/* // new slide awards   */}

                            <div class="banner-slide lsegaward_slide">
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="banner-head fontNew banner-text">
                                                <span className="isegawardi_companyprovider">LSEG StarMine</span>
                                                <div className="isegawardimg_mobile">
                                                    <img src={LSEGforecastingaward} alt="Moneysukh Top Banner" class="img-fluid isegaward-img" />
                                                </div>
                                                <span className="lsegaward_companyname">Awarded Moneysukh for Most Accurate Forecasting </span>
                                                in Reuters Polls <a href="https://www.lseg.com/en/data-analytics/starmine-forecaster-awards/quarterly-award-winners#global">Know More...</a>
                                            </div>

                                            {/* <p className="event-text">
                                            Mansukh Securities & Finance Ltd. has been recognised as the winner for the Q3 2024 LSEG StarMine Award for
                                             Most Accurate Forecasting in Reuters Polls.
                                            </p> */}
                                            {isSuccess ? "" : <div className="maincta_section">
                                                <form className="maincta_form">
                                                    <div class="form-row">
                                                        <div class="col-md-7 col-sm-12">
                                                            {otpfieldenable == false && <div class="input-group mb-2">
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">+91</div>
                                                                </div>
                                                                <input type="number" class="form-control" id="EnterMobileNumberis" placeholder="Enter your Mobile number" value={mobNumber} onChange={handleNewUserMobileNumber} />
                                                                {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                          {/* aria-label="Enter Mobile Number" */}
                                                                        <button type="submit" class="btn btn-primary" aria-label="Enter Mobile Number" onClick={(e) => OtpSend(e)}>{ArrowRight}</button>
                                                                    </div>
                                                                </div>
                                                            </div>}

                                                            {otpfieldenable && <div class="inputctaopt_grid">
                                                                <div class="input-group mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text" onClick={(e) => setshowpwdnew(!showpwdnew)}>{showpwdnew ? Eye : EyeSlash}</div>
                                                                    </div>
                                                                    <div class="inputctaopt_group form-control">
                                                                          <OTPInput
                                                                            inputType={showpwdnew ? "text" : "password"}

                                                                            value={otpis1}
                                                                            onChange={setotpis1}
                                                                            numInputs={4}
                                                                            renderSeparator={<span></span>}
                                                                            inputStyle={{
                                                                                width: '31px',
                                                                                height: '35px',
                                                                                margin: '0 8px',
                                                                                fontSize: '20px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #ccc',
                                                                                textAlign: 'center'
                                                                            }}
                                                                            renderInput={(props) => <input {...props} />}
                                                                        />
                                                                    </div>
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text">
                                                                            <button type="submit" class="btn btn-primary" onClick={(e) => verifyOtp(e)} >{ArrowRight}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 className="otprecvresend_text">{resendDisabled ? <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> : <span>Didn’t received? <span className="resent_otp" onClick={(e) => OtpSend(e)}>Resend OTP</span></span>}</h6>
                                                            </div>}
                                                        </div>
                                                        <div class="col-md-5 col-sm-12 text-center investmentmaincta_calmn">
                                                            <div className="investmentmaincta_list">
                                                                <div className="investmentmaincta_panel d-flex">
                                                                    <div className="scnner_panel">
                                                                        <img src={scanner} alt="Scan the QR Code"></img>
                                                                    </div>
                                                                    <div className="scnner_text">
                                                                        <p>Scan the QR Code to</p>
                                                                        <strong>Login<small>/</small>Register</strong>
                                                                        <p>from your mobile</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                            {/* <a class="bttn lsegaward_btn" href="https://www.lseg.com/en/data-analytics/starmine-forecaster-awards/quarterly-award-winners#global" target="_blanck">
                                               KNOW MORE
                                            </a> */}
                                            <div className="groupbtnn">
                                                {data && data.map((item, index) => (
                                                    <>
                                                        {index <= 1 ? (<button className="ineerbtn" onClick={routeIndexHome}>{item.co_name} <span className={(item.netchg > 0) ? "numt num-green" : "numt num-red"}>
                                                            {item.close_price}
                                                            {item.netchg > 0 ? <img className="arrowimg" src={upArrow} alt="Up Arrow" /> : <img className="arrowimg" src={down} alt="Down Arrow" />}</span></button>) : ''}

                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12 isegawardimg_desktop">
                                            <div class="img-container img-banner">
                                                <img src={LSEGforecastingaward} alt="Moneysukh Top Banner" class="img-fluid isegaward-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Slider>
                    </div>

                </section>

                <section class="home_pricing-sc">
                    <div class="container">
                        <div class="row">

                            <div class="col-lg-6 col-md-12">
                                <h2 class="section-heading">
                                    Our Pricing
                                </h2>
                                <ul>
                                    <li>
                                        <strong>0</strong> Account Opening Charges
                                    </li>
                                    <li>
                                        <strong>0</strong> Account Maintenance Charges (For 1st Year only)
                                    </li>
                                    <li>
                                        <strong>0</strong> Charges for Research tools
                                    </li>
                                    <li>
                                        <strong>0</strong> Charges for Delivery (Plan A)
                                    </li>
                                    <li>
                                        Flexible brokerage plans
                                    </li>
                                </ul>

                                <div class="plan-container">
                                    <div class="plan-box">
                                        <h3 class="plan">Plan A</h3>
                                        <div class="amount">
                                            <span class="rupee-container"  aria-hidden="true"><small>₹</small>
                                                {/* <img src={Rupee_blue} alt="" /> */}
                                            </span>
                                            20
                                        </div>
                                        <p class="text">Per order + FREE delivery
                                            Brokerage</p>
                                    </div>
                                    <div class="plan-box">
                                        <h3 class="green plan">Plan B</h3>
                                        <div class="green amount">
                                            <span class="rupee-container" aria-hidden="true"><small>₹</small>
                                                {/* <img src={Rupee_green} alt="" /> */}
                                            </span>
                                            10
                                        </div>
                                        <p class="text">Per order only <br></br>
                                            ( No hidden charges)</p>
                                    </div>
                                </div>

                                <button class="bttn" onClick={routePricingHome}>
                                    Discover More
                                </button>

                            </div>
                            <div class="col-lg-6 col-md-12">
                                <div class=" text-center">
                                    <img src={new_pricing} alt="Our Pricing" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
                <WhyUsNew />
                <section class="home_product-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h2 class="section-heading center">
                                    Our Products
                                </h2>
                                <div class="product-grid-container">
                                    <div class="product-card">
                                        <div class="img-container">
                                            <img src={new_product1} alt="Moneysukh Equity investment" />
                                        </div>
                                        <div class="content">
                                            <div class="head">
                                                Equity
                                            </div>
                                            <p>
                                                Invest in stock from comfort of your home and earn a chance to get inflation beating returns.
                                            </p>
                                            <button class="bttn" onClick={routeProductHome}>
                                                <p>Read more</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="product-card">
                                        <div class="img-container">
                                            <img src={new_product2} alt="Moneysukh IPO investment" />
                                        </div>
                                        <div class="content">
                                            <div class="head">
                                                IPO
                                            </div>
                                            <p>
                                                Get in-depth analysis of companies that are about to hit the market through Initial public offering.
                                            </p>
                                            <button class="bttn" onClick={routeProductHome}>
                                                <p>Read more</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="product-card">
                                        <div class="img-container">
                                            <img src={new_product3} alt="Moneysukh Mutual Fund investment" />
                                        </div>
                                        <div class="content">
                                            <div class="head">
                                                Mutual Fund
                                            </div>
                                            <p>
                                                Start with a small amount and see your corpus grow over time by investing in mutual funds.
                                            </p>
                                            <button class="bttn" onClick={routeProductHome}>
                                                <p>Read more</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="product-card">
                                        <div class="img-container">
                                            <img src={new_product4} alt="Moneysukh Futures & Options investment" />
                                        </div>
                                        <div class="content">
                                            <div class="head">
                                                Futures & Options
                                            </div>
                                            <p>
                                                Trade in F&O with the help of readymade option strategy builder.
                                            </p>
                                            <button class="bttn" onClick={routeProductHome}>
                                                <p>Read more</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="product-card">
                                        <div class="img-container">
                                            <img src={new_product5} alt="Moneysukh Currency investment" />
                                        </div>
                                        <div class="content">
                                            <div class="head">
                                                Currency
                                            </div>
                                            <p>
                                                Trade in wide range of currency pairs to hedge, speculate or diversify your portfolio.
                                            </p>
                                            <button class="bttn" onClick={routeProductHome}>
                                                <p>Read more</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="product-card">
                                        <div class="img-container">
                                            <img src={new_product6} alt="Moneysukh Commodities investment" />
                                        </div>
                                        <div class="content">
                                            <div class="head">
                                                Commodities
                                            </div>
                                            <p>
                                                Trade in commodities like crude oil, gold, and silver to gain from economic trends and arbitrage opportunities.
                                            </p>
                                            <button class="bttn" onClick={routeProductHome}>
                                                <p>Read more</p>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

                <section class="home_integration-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h2 class="section-heading center">
                                    Our Integrations
                                </h2>

                                <div class="integration-grid-container">

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Fox Trader</div>
                                            <p>Powerful Charting software, where you can backtest your strategies for successful trading with 200+ conditions.</p>
                                            <button class="bttn" onClick={routeFoxTraderHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                01
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={new_integration1} alt="Fox Trader" class="img-fluid" />
                                        </div>
                                    </div>

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">TradingView</div>
                                            <p>Where the world charts, chats and trades markets. We're a charting platform and social network for traders and investors.</p>
                                            <button class="bttn" onClick={routeTradingViewHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                02
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={new_integration2} alt="TradingView" class="img-fluid" />
                                        </div>
                                    </div>

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Smart Options</div>
                                            <p>Trade Options from real time charts. No more toggling in search windows to create your option strategies.</p>
                                            <button class="bttn" onClick={routeSmartOptionHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                03
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={new_integration3} alt="Smart Options" class="img-fluid" />
                                        </div>
                                    </div>
                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Trade Radar</div>
                                            <p>
                                                Trade Radar is a no-code algorithm trading platform that provides backtesting, optimization & fully automated live trading.
                                            </p>
                                            <button class="bttn" onClick={routeKeevHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                04
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={TradeRadarnew} alt="Trade Radar New" class="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

            </main>

        </>
    );
}

export default WelcomeNew;
